import { useMemo } from 'react'
import { Select } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'

import { permissionsApi } from '@/api/permissions'

/** Onde o robô fica: um dos Perfis da tela de Permissões (pedido de
 *  27/09/2026, TASK-11860). Grava o NOME em `robos.location`, que segue
 *  texto — o contrato do backend não muda. */
export function SeletorDeLocal({ value, onChange }: {
  value: string
  onChange: (local: string) => void
}) {
  // Mesma chave da tela de Permissões: as duas leem o mesmo cache.
  const { data: perfis } = useQuery({
    queryKey: ['permission-templates'],
    queryFn: () => permissionsApi.listTemplates(),
    staleTime: 60_000,
  })
  const opcoes = useMemo(() => {
    // `Select` recusa valor repetido, e nome de perfil não é UNIQUE no banco.
    const nomes = new Set((perfis ?? []).map((p) => p.name))
    // Local gravado antes da lista ("a definir", "Térreo") fica como opção:
    // fora dela o Select mostraria o campo vazio, e o robô pareceria sem local.
    if (value) nomes.add(value)
    return [...nomes].sort((a, b) => a.localeCompare(b, 'pt-BR'))
  }, [perfis, value])

  return (
    <Select
      label="Local"
      description="Um dos Perfis da tela de Permissões."
      placeholder="Escolha o perfil"
      data={opcoes}
      searchable
      clearable
      nothingFoundMessage="Nenhum perfil com esse nome"
      value={value || null}
      onChange={(v) => onChange(v ?? '')}
    />
  )
}
